import workspace from "./workspace";
import { getFilteredWorkspaceData } from "@/utils/workspaceOrgFilter";


export const getBinarys = async () => {
  try {
    return getFilteredWorkspaceData('/binary/');
  } catch (error) {
    console.error("Error fetching agents:", error);
    throw error;
  }
};


export const getBinarysById = async (id) => {
  try {
    const response = await workspace.get(`/binary/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching agent with ID ${id}:`, error);
    throw error;
  }
};


export const createBinary = async (binaryData) => {
  try {
    const response = await workspace.post(`/binary/`, binaryData,{
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error creating agent:", error);
    throw error;
  }
};


export const createBinaryChunks = async (id,binaryData) => {
  try {
    const response = await workspace.post(`/binary/${id}/chunks/`, binaryData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error creating agent:", error);
    throw error;
  }
};


export const initializeStaging = async (binaryId, data) => {
  const response = await workspace.post(`/binary/${binaryId}/stage/`, data);
  return response.data;
};


export const updateFile = async (id, binaryData) => {
  try {
      const response = await workspace.post(`/binary/${id}/stage/`, binaryData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Error updating agent with ID ${id}:`, error);
      throw error;
    }
}


export const updateUsers = async (id, binaryData) => {
  try {
      const response = await workspace.post(`/binary/${id}/users/`, binaryData, {
      });
      return response.data;
    } catch (error) {
      console.error(`Error updating agent with ID ${id}:`, error);
      throw error;
    }
}


export const approveBinary = async (id) => {
  try {
      const response = await workspace.post(`/binary/${id}/approve/`, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Error updating agent with ID ${id}:`, error);
      throw error;
    }
}


export const denyBinary = async (id) => {
  try {
      const response = await workspace.post(`/binary/${id}/deny/`, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Error updating agent with ID ${id}:`, error);
      throw error;
    }
}


export const updateBinary = async (id, binaryData) => {
  try {
    const response = await workspace.put(`/binary/${id}/`, binaryData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error(`Error updating agent with ID ${id}:`, error);
    throw error;
  }
};


export const getBinarysForPlatform = async ({ os = null, arch = null, org = null, spaceType = null } = {}) => {
  try {
    const params = {};
    if (os) params.osFilter = os;
    if (arch) params.archFilter = arch;
    if (org) params.organization = org;
    if (spaceType) params.spaceType = spaceType;
    const response = await workspace.get('/binary/filter-by-platform/', { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching binaries for platform:", error);
    throw error;
  }
};


export const deleteBinary = async (id) => {
  try {
    const response = await workspace.delete(`/binary/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting agent with ID ${id}:`, error);
    throw error;
  }
};
